// Light/dark theme: kept as a data-theme attribute on <html> (styles in index.css) and remembered in localStorage.
const KEY = 'theme';

export const getTheme = () => (document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light');

export function setTheme(theme) {
  document.documentElement.dataset.theme = theme;
  try { localStorage.setItem(KEY, theme); } catch { /* private mode: the choice just isn't remembered */ }
}

// Called once before the first render so the page never flashes the wrong theme.
export function initTheme() {
  try { document.documentElement.dataset.theme = localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'; } catch { /* default light */ }
}
